module.exports = __webpack_public_path__ + "static/media/moon_blue-min.8265f883.png";